const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "avif"];

const SPORTS_IMAGE_STRIP_TERMS = {
  football: ["football", "nfl"],
  hockey: ["hockey", "nhl", "puck"],
  basketball: ["basketball", "nba", "hoops"],
  soccer: ["soccer", "fifa", "world cup", "uefa", "premier league", "champions league", "bundesliga", "la liga", "serie a"],
  baseball: ["baseball", "mlb"],
};

const SPORTS_SET_IMAGE_OVERRIDES = {
  football: {
    "2025-panini-prizm-football": ["/sets/football/prizm-2025.jpg"],
    "2025-donruss-optic-football": ["/sets/football/optic-2025.png"],
    "2025-donruss-football": ["/sets/football/donruss-2025.jpg"],
    "2025-panini-absolute-football": ["/sets/football/absolute-2025.webp"],
    "2025-topps-chrome-football": ["/sets/football/topps-chrome-2025.webp"],
  },
  hockey: {
    "2025-26-upper-deck-series-one-hockey": ["/sets/hockey/series-one-2025.webp"],
    "2025-26-upper-deck-series-two-hockey": ["/sets/hockey/series-two-2025.avif"],
    "2025-26-allure-hockey": ["/sets/hockey/allure-2025.png"],
    "2025-26-o-pee-chee-hockey": ["/sets/hockey/opeechee-2025.png"],
  },
  basketball: {
    "2025-26-bowman-basketball": ["/sets/basketball/bowman-basketball-2025.webp"],
    "2025-topps-chrome-basketball": ["/sets/basketball/topps-chrome-2025.webp"],
    "2025-topps-flagship-basketball": ["/sets/basketball/topps-flagship-basketball-2025.webp"],
  },
  soccer: {
    "2025-topps-club-world-cup-soccer": ["/sets/soccer/club-world-cup-2025.jpg"],
    "2024-25-panini-donruss-soccer": ["/sets/soccer/donruss-2024.webp"],
    "2025-topps-mls-chrome-soccer": ["/sets/soccer/mls-topps-chrome-2025.png"],
    "2025-topps-flagship-soccer": ["/sets/soccer/topps-flagship-soccer-2025.webp"],
  },
  baseball: {
    "2025-topps-series-one-baseball": ["/sets/baseball/topps-series-one-baseball-2025.jpg"],
    "2025-topps-series-two-baseball": ["/sets/baseball/topps-series-two-baseball-2025.png"],
    "2025-topps-chrome-baseball": ["/sets/baseball/topps-chrome-baseball-2025.webp"],
    "2025-topps-chrome-update-baseball": ["/sets/baseball/topps-chrome-update-2025.jpg"],
    "2025-topps-update-series-baseball": ["/sets/baseball/topps-update-series-2025.avif"],
    "2025-topps-celebrations-series-one-baseball": ["/sets/baseball/topps-celebrations-series-one-2025.webp"],
  },
};

const SPORTS_SET_CONFIG = {
  baseball: {
    key: "baseball",
    title: "Baseball Cards",
    shortTitle: "Baseball",
    routePath: "/sets/baseball",
    setRouteBase: "/sports/baseball/sets",
    fallbackImages: ["/sets/baseball%20sets.webp"],
    accent: "#b44d35",
    chipBg: "rgba(255,255,255,0.18)",
    heroGradient: "linear-gradient(135deg, #3a1f19 0%, #6e3c28 54%, #d47c46 100%)",
    cardBg: "#fcf8f4",
  },
  football: {
    key: "football",
    title: "Football Cards",
    shortTitle: "Football",
    routePath: "/sets/football",
    setRouteBase: "/sports/football/sets",
    fallbackImages: ["/sets/football%20sets.jpg"],
    accent: "#b55f2f",
    chipBg: "rgba(255,255,255,0.18)",
    heroGradient: "linear-gradient(135deg, #13263d 0%, #21446c 56%, #d88a3a 100%)",
    cardBg: "#fbfaf7",
  },
  hockey: {
    key: "hockey",
    title: "Hockey Cards",
    shortTitle: "Hockey",
    routePath: "/sets/hockey",
    setRouteBase: "/sports/hockey/sets",
    fallbackImages: ["/sets/hockey%20sets.avif"],
    accent: "#2e6f9c",
    chipBg: "rgba(255,255,255,0.18)",
    heroGradient: "linear-gradient(135deg, #102338 0%, #1d4c78 56%, #9cb7d8 100%)",
    cardBg: "#f8fbff",
  },
  basketball: {
    key: "basketball",
    title: "Basketball Cards",
    shortTitle: "Basketball",
    routePath: "/sets/basketball",
    setRouteBase: "/sports/basketball/sets",
    fallbackImages: ["/sets/basketball%20sets.webp"],
    accent: "#c76a1f",
    chipBg: "rgba(255,255,255,0.18)",
    heroGradient: "linear-gradient(135deg, #2a1f10 0%, #6f4e1a 52%, #e6a54a 100%)",
    cardBg: "#fcfaf5",
  },
  soccer: {
    key: "soccer",
    title: "Soccer Cards",
    shortTitle: "Soccer",
    routePath: "/sets/soccer",
    setRouteBase: "/sports/soccer/sets",
    fallbackImages: ["/sets/soccer%20sets.jpg"],
    accent: "#2f8a77",
    chipBg: "rgba(255,255,255,0.18)",
    heroGradient: "linear-gradient(135deg, #102823 0%, #1f6258 55%, #d0a54f 100%)",
    cardBg: "#f8fbfa",
  },
};

function normalizeSlug(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();
}

function escapeRegExp(value) {
  return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function normalizeSportKey(value) {
  const text = String(value || "").trim().toLowerCase();
  if (!text) return "";
  if (text.includes("football")) return "football";
  if (text.includes("hockey")) return "hockey";
  if (text.includes("basketball")) return "basketball";
  if (text.includes("soccer")) return "soccer";
  return text;
}

function getSportsSetConfig(value) {
  return SPORTS_SET_CONFIG[normalizeSportKey(value)] || SPORTS_SET_CONFIG.football;
}

function sportsSetSlugFromName(name) {
  return normalizeSlug(name);
}

function normalizeSportsSetImageKey(value, sport, { stripSportWords = false } = {}) {
  let text = String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['’]/g, "")
    .replace(/&/g, " and ")
    .toLowerCase();

  text = text
    .replace(/\bo[\s-]*pee[\s-]*chee\b/g, "opeechee")
    .replace(/\bupper\s+deck\s+series\s+one\b/g, "series one")
    .replace(/\bupper\s+deck\s+series\s+two\b/g, "series two")
    .replace(/\bupper\s+deck\b/g, " ")
    .replace(/\bseries\s+one\b/g, "series one")
    .replace(/\bseries\s+two\b/g, "series two");

  const key = normalizeSportKey(sport);
  if (stripSportWords && SPORTS_IMAGE_STRIP_TERMS[key]) {
    for (const term of SPORTS_IMAGE_STRIP_TERMS[key]) {
      text = text.replace(new RegExp(`\\b${escapeRegExp(term)}\\b`, "g"), " ");
    }
  }

  return text
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function pushUnique(list, seen, value) {
  const text = String(value || "").trim();
  if (!text || seen.has(text)) return;
  seen.add(text);
  list.push(text);
}

function pushAliasCandidates(list, seen, sport, key) {
  const aliases = SPORTS_SET_IMAGE_OVERRIDES[normalizeSportKey(sport)] || {};
  const values = aliases[String(key || "").trim().toLowerCase()] || [];
  for (const value of values) {
    pushUnique(list, seen, value);
  }
}

function buildSportsSetImageCandidates(entry, sport) {
  const config = getSportsSetConfig(sport || entry?.sport || entry?.category);
  const candidates = [];
  const seen = new Set();

  if (String(entry?.imageFile || "").trim()) {
    const file = String(entry.imageFile).trim().replace(/^\/+/, "");
    pushUnique(candidates, seen, `/sets/${config.key}/${encodeURI(file)}`);
  }

  const sourceCandidates = Array.from(new Set([
    String(entry?.set_name || "").trim(),
    String(entry?.slug || "").trim(),
    sportsSetSlugFromName(entry?.set_name || ""),
  ].filter(Boolean)));

  for (const source of sourceCandidates) {
    const directKey = normalizeSportsSetImageKey(source, config.key, { stripSportWords: false });
    const strippedKey = normalizeSportsSetImageKey(source, config.key, { stripSportWords: true });
    const slugKey = normalizeSlug(source);

    if (slugKey) {
      pushAliasCandidates(candidates, seen, config.key, slugKey);
    }
    if (directKey && directKey !== slugKey) {
      pushAliasCandidates(candidates, seen, config.key, directKey);
    }
    if (strippedKey && strippedKey !== directKey && strippedKey !== slugKey) {
      pushAliasCandidates(candidates, seen, config.key, strippedKey);
    }

    for (const key of [slugKey, directKey, strippedKey].filter((value, index, list) => value && list.indexOf(value) === index)) {
      for (const ext of IMAGE_EXTENSIONS) {
        pushUnique(candidates, seen, `/sets/${config.key}/${encodeURI(`${key}.${ext}`)}`);
      }
    }
  }

  for (const fallback of config.fallbackImages) {
    pushUnique(candidates, seen, fallback);
  }

  return candidates;
}

function sortByCountThenName(a, b) {
  return (Number(b.item_count || 0) - Number(a.item_count || 0))
    || String(a.set_name || "").localeCompare(String(b.set_name || ""));
}

function sortSportsSetEntries(sets, sortBy) {
  const list = Array.isArray(sets) ? [...sets] : [];
  switch (String(sortBy || "newest").trim().toLowerCase()) {
    case "oldest":
      return list.sort((a, b) => (Number(a.year || 0) - Number(b.year || 0)) || sortByCountThenName(a, b));
    case "name_asc":
      return list.sort((a, b) => String(a.set_name || "").localeCompare(String(b.set_name || "")) || sortByCountThenName(a, b));
    case "name_desc":
      return list.sort((a, b) => String(b.set_name || "").localeCompare(String(a.set_name || "")) || sortByCountThenName(a, b));
    case "item_count":
    case "item_count_desc":
      return list.sort(sortByCountThenName);
    case "newest":
    default:
      return list.sort((a, b) => (Number(b.year || 0) - Number(a.year || 0)) || sortByCountThenName(a, b));
  }
}

function getSportsSetListPath(sport) {
  return getSportsSetConfig(sport).routePath;
}

function getSportsSetRouteBase(sport) {
  return getSportsSetConfig(sport).setRouteBase;
}

function getSportsSetRoutePath(sport, setSlug) {
  return `${getSportsSetRouteBase(sport)}/${String(setSlug || "").trim().toLowerCase()}`;
}

export {
  SPORTS_SET_CONFIG,
  buildSportsSetImageCandidates,
  getSportsSetConfig,
  getSportsSetListPath,
  getSportsSetRouteBase,
  getSportsSetRoutePath,
  normalizeSportKey,
  sortSportsSetEntries,
  sportsSetSlugFromName,
};
